import OapEventfulTextInput from './code/Scripts/components/OapEventfulTextInput.vue';

export default {
  components: {
    OapEventfulTextInput,
  },
};
